import { formatDate } from "@/helpers";

const state = () => ({
  pendingPayments: [],
  paidPayments: []
});

const getters = {
  pendingPayments: state => {
    return state.pendingPayments;
  },
  paidPayments: state => {
    return state.paidPayments;
  }
};

const actions = {
  async fetchPendingPayments({ commit }, { taxId }) {
    const { data } = await this.$http.get(`clients/${taxId}/payments/pending`);
    commit("setPendingPayments", data);
  },
  async fetchPaidPayments({ commit }, { id }) {
    const { data } = await this.$http.get(`clients/${id}/payments/paid`, {
      params: {
        limit: 5
      }
    });
    commit("setPaidPayments", data);
  }
};

const mutations = {
  setPendingPayments(state, data) {
    state.pendingPayments = data.sort(
      (a, b) => new Date(formatDate(a.date)) - new Date(formatDate(b.date))
    );
  },
  setPaidPayments(state, data) {
    state.paidPayments = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
